// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16yyK","inner":"Footer_inner__373pL"};